import React, { useEffect, useState, memo } from "react";
import styles from "./VideoThumbnail.module.scss";

const VideoThumbnail = ({ url, thumbnailSize = "large" }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchThumbnail = async () => {
      if (!url) {
        setLoading(false);
        setError("No video URL provided");
        return;
      }
      try {
        const videoId = url.split("/").filter(Boolean).pop();

        if (!videoId || isNaN(videoId)) {
          throw new Error("Invalid Vimeo URL format");
        }

        const response = await fetch(
          `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(
            url
          )}&width=1000&height=800`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const thumbUrl = data.thumbnail_url;

        if (!thumbUrl) {
          throw new Error("No thumbnail URL found in response");
        }

        setThumbnailUrl(thumbUrl);
      } catch (err) {
        console.error("Failed to load thumbnail:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchThumbnail();
  }, [url]);

  if (loading) return <div className={styles.loader}></div>;
  if (error) return <div className={styles.error}>Video thumbnail</div>;

  return (
    <div className={styles.thumbnailContainer}>
      <img
        src={thumbnailUrl}
        alt="Video thumbnail"
        className={styles.thumbnailImage}
        loading="lazy"
        crossOrigin="anonymous"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/fallback-thumbnail.jpg";
        }}
      />
      <div className={styles.videoBadge}></div>
    </div>
  );
};

export default memo(VideoThumbnail, (prevProps, nextProps) => {
  return (
    prevProps.url === nextProps.url &&
    prevProps.thumbnailSize === nextProps.thumbnailSize
  );
});
